exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".a-ph {\n  font-style: italic;\n  color: #a3a3a3;\n  font-size: 12px;\n}\n@media (max-width: 576px) {\n#ad img {\n    width: 100%;\n}\n}\n@media (min-width: 578px) {\n.c729 {\n    width: 729px;\n    height: 90px;\n}\n.c250 {\n    width: 250px;\n    height: 250px;\n}\n.c370 {\n    width: 370px;\n    height: 370px;\n}\n}", ""]);

// exports
